(function () {
  'use strict';

  var config = window.themeCustomConfig || {};
  var blinkTimer = null;
  var blinkOn = true;
  var lastCount = Number(config.cartCount) || 0;
  var originalTitle = document.title;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1500 });
    } else {
      window.setTimeout(callback, 0);
    }
  }

  function addSwatchLabels() {
    var allowedTypes = ['t-shirt', 'tank', 'hoodie', 'crewneck'];

    document.querySelectorAll('.color-swatch').forEach(function (label) {
      var dataColor = label.getAttribute('data-color');
      if (!dataColor) return;

      var lastWord = dataColor.trim().toLowerCase().split(' ').pop();
      if (allowedTypes.indexOf(lastWord) === -1) return;

      var wrapper = label.closest('.swatch-wrapper');
      if (!wrapper || wrapper.querySelector('.swatch-label')) return;

      var text = document.createElement('div');
      text.className = 'swatch-label';
      text.textContent = lastWord.charAt(0).toUpperCase() + lastWord.slice(1);
      wrapper.appendChild(text);
    });
  }

  function getFaviconLink() {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    return link;
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        resolve(image);
      };
      image.onerror = reject;
      image.src = src;
    });
  }

  function stopBlink() {
    if (blinkTimer) window.clearInterval(blinkTimer);
    blinkTimer = null;
  }

  function drawFavicon(count, showBadge) {
    var link = getFaviconLink();
    var baseHref = link.dataset.base || config.faviconUrl || link.href || '/favicon.ico';
    link.dataset.base = baseHref;

    if (!count || !showBadge) {
      link.href = baseHref;
      return Promise.resolve();
    }

    return loadImage(baseHref)
      .then(function (image) {
        var size = 256;
        var radius = Math.round(size * 0.45 * 0.5);
        var padding = Math.round(size * 0.08);
        var centerX = padding + radius;
        var centerY = size - padding - radius;
        var text = count > 99 ? '99+' : String(count);
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        canvas.width = size;
        canvas.height = size;
        context.drawImage(image, 0, 0, size, size);
        context.beginPath();
        context.fillStyle = '#ef4444';
        context.arc(centerX, centerY, radius, 0, Math.PI * 2);
        context.fill();

        var fontSize = Math.round(radius * 1.1);
        if (text.length === 2) fontSize = Math.round(radius * 0.9);
        if (text.length >= 3) fontSize = Math.round(radius * 0.75);

        context.fillStyle = '#ffffff';
        context.font = '900 ' + fontSize + 'px Arial';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(text, centerX, centerY + Math.round(radius * 0.05));
        link.href = canvas.toDataURL('image/png');
      })
      .catch(function () {
        link.href = baseHref;
      });
  }

  function updateFavicon(count) {
    var nextCount = Number(count) || 0;
    stopBlink();
    lastCount = nextCount;

    if (!nextCount) {
      drawFavicon(0, false);
      return;
    }

    blinkOn = true;
    drawFavicon(nextCount, true);
    blinkTimer = window.setInterval(function () {
      blinkOn = !blinkOn;
      drawFavicon(nextCount, blinkOn);
    }, 2500);
  }

  function subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      if (cartData && typeof cartData.item_count === 'number') {
        updateFavicon(cartData.item_count);
        return;
      }

      window
        .fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart) updateFavicon(cart.item_count);
        })
        .catch(function () {});
    });
  }

  function installMediaModalClose() {
    document.addEventListener(
      'click',
      function (event) {
        var modal = event.target.closest('media-modal, .media-modal, .lightbox, .product-zoom-modal, .Modal');
        if (!modal) return;
        if (event.target.closest('.modal__close-button, [data-close], button, a, input, textarea, select, video, iframe')) {
          return;
        }

        var clickedImage = event.target.tagName === 'IMG' || Boolean(event.target.closest('img'));
        var clickedBackdrop =
          event.target === modal ||
          event.target.classList.contains('modal__content') ||
          event.target.classList.contains('media-modal__content');
        if (!clickedImage && !clickedBackdrop) return;

        var closeButton = modal.querySelector('.modal__close-button, [data-close]');
        if (closeButton) {
          closeButton.click();
        } else if (typeof modal.hide === 'function') {
          modal.hide();
        } else if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.classList.remove('is-open', 'open', 'active');
          document.body.classList.remove('overflow-hidden', 'media-modal-open');
          document.documentElement.classList.remove('overflow-hidden');
        }
      },
      { passive: true }
    );
  }

  function startTitleRotation() {
    var messages = [originalTitle, 'Free Returns 🔄', 'Fast Shipping 🚚', '30 Day Guarantee ✅'];
    var messageIndex = 0;

    window.setInterval(function () {
      document.title = messages[messageIndex];
      messageIndex = (messageIndex + 1) % messages.length;
    }, 5000);
  }

  function loadKlaviyo() {
    if (!config.klaviyoCompanyId || document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) return;

    var script = document.createElement('script');
    script.async = true;
    script.src =
      'https://static.klaviyo.com/onsite/js/' +
      encodeURIComponent(config.klaviyoCompanyId) +
      '/klaviyo.js?company_id=' +
      encodeURIComponent(config.klaviyoCompanyId);
    document.head.appendChild(script);
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function loadKlaviyoOnInteraction(fallbackDelay, includeScroll) {
    var loaded = false;
    var fallbackTimer = null;
    var events = ['pointerdown', 'keydown', 'touchstart'];

    if (includeScroll !== false) {
      events.push('scroll');
    }

    function loadOnce() {
      if (loaded) return;
      loaded = true;
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      events.forEach(function (eventName) {
        window.removeEventListener(eventName, loadOnce, { passive: true });
      });
      runWhenIdle(loadKlaviyo);
    }

    events.forEach(function (eventName) {
      window.addEventListener(eventName, loadOnce, { once: true, passive: true });
    });

    if (fallbackDelay) {
      fallbackTimer = window.setTimeout(loadOnce, fallbackDelay);
    }
  }

  function scheduleKlaviyo() {
    if (document.querySelector('[class*="klaviyo-form-"]')) {
      loadKlaviyo();
      return;
    }

    if (config.pageType === 'collection') {
      loadKlaviyoOnInteraction();
      return;
    }

    if (config.pageType === 'product' && isMobileViewport()) {
      loadKlaviyoOnInteraction(20000, false);
      return;
    }

    loadKlaviyoOnInteraction(9000);
  }

  function initMobileCollectionReveal() {
    var revealButtons = document.querySelectorAll('[data-mobile-collection-reveal]');
    if (!revealButtons.length) return;

    revealButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var container = button.closest('.product-grid-container');
        if (!container) return;

        container.classList.add('mobile-reveal-expanded');
        button.setAttribute('hidden', 'hidden');
      });
    });
  }

  function hydrateDeferredGridResources() {
    var grids = document.querySelectorAll('[data-defer-grid-resources]');
    if (!grids.length) return;

    function hydrateGrid(grid) {
      if (!grid || grid.hasAttribute('data-grid-resources-loaded')) return;
      grid.setAttribute('data-grid-resources-loaded', 'true');

      grid.querySelectorAll('img[data-src], source[data-src]').forEach(function (element) {
        element.src = element.dataset.src;
        element.removeAttribute('data-src');
      });

      grid.querySelectorAll('img[data-srcset], source[data-srcset]').forEach(function (element) {
        element.srcset = element.dataset.srcset;
        element.removeAttribute('data-srcset');
      });

      grid.querySelectorAll('video[data-deferred-video]').forEach(function (video) {
        video.load();
        if (video.hasAttribute('autoplay')) video.play().catch(function () {});
      });
    }

    if (!('IntersectionObserver' in window)) {
      grids.forEach(hydrateGrid);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrateGrid(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );

    grids.forEach(function (grid) {
      observer.observe(grid);
    });
  }

  onReady(function () {
    addSwatchLabels();
    installMediaModalClose();
    subscribeToCartUpdates();
    scheduleKlaviyo();
    hydrateDeferredGridResources();
    initMobileCollectionReveal();
    runWhenIdle(function () {
      updateFavicon(lastCount);
    });
  });

  window.addEventListener('load', function () {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
  });

  startTitleRotation();
})();
